export enum NotificationType {
    SYSTEM = 'system',
    PAYMENT = 'payment',
    USER = 'user',
}

interface NotificationContext {
    redirect_url?: string;
    title?: string;
    description?: string;
    content?: string;
    created_at?: string;
}

export interface INotification {
    id: number;
    title: string;
    created_at: string;
    text: string;
    type: NotificationType;
    is_viewed: boolean;
    context: NotificationContext | null;
    image: {
        url: string;
    };
}

export interface ModalSystemContent {
    content: string;
    header: string;
    date: string;
}
